import { InternalConversation } from '@/lib/api/internal-chat/internal-chat-api'
import ConversationItem from './ConversationItem'

interface ConversationListProps {
    conversations: InternalConversation[]
    currentId?: number
    currentUserId: number
    onSelect: (id: number) => void
    loading?: boolean
}

export default function ConversationList({
    conversations,
    currentId,
    currentUserId,
    onSelect,
    loading,
}: ConversationListProps) {
    if (loading) {
        return (
            <div className="flex items-center justify-center h-full">
                <span className="loading loading-spinner loading-md"></span>
            </div>
        )
    }

    if (conversations.length === 0) {
        return (
            <div className="flex flex-col items-center justify-center h-full text-base-content/50 p-4 text-center">
                <p className="text-sm">Nenhuma conversa ainda</p>
                <p className="text-xs mt-1">
                    Inicie uma nova conversa usando o botão acima
                </p>
            </div>
        )
    }

    return (
        <div className="overflow-y-auto h-full">
            {conversations.map(conversation => (
                <ConversationItem
                    key={conversation.id}
                    conversation={conversation}
                    isActive={conversation.id === currentId}
                    currentUserId={currentUserId}
                    onClick={() => onSelect(conversation.id)}
                />
            ))}
        </div>
    )
}
